import { render, staticRenderFns } from "./ScreenNeurosonografia.vue?vue&type=template&id=4d5bc6f0&scoped=true&"
import script from "./ScreenNeurosonografia.vue?vue&type=script&lang=js&"
export * from "./ScreenNeurosonografia.vue?vue&type=script&lang=js&"
import style0 from "./ScreenNeurosonografia.vue?vue&type=style&index=0&id=4d5bc6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bc6f0",
  null
  
)

export default component.exports